import { Modal, Tabs } from '@employ-engage/common-components';
import { useState } from 'react';
import AddEmployeesBulkForm from '../add-employees-bulk-form/add-employees-bulk-form';
import AddEmployeeForm from '../add-employee-form/add-employee-form';
import { BasicTableDataRow } from '@employ-engage/data';
import { useTranslation } from 'react-i18next';

export interface AddEmployeeModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  employeeSelectedForEditing?: BasicTableDataRow | null;
  employeeSelectedForEditingHasValidDepartment?: boolean;
  refetchEmployeeList: () => void;
}

export function AddEmployeeModal({
  open,
  setOpen,
  employeeSelectedForEditing,
  employeeSelectedForEditingHasValidDepartment,
  refetchEmployeeList,
}: AddEmployeeModalProps) {
  const { t } = useTranslation(['common']);
  const [currentTab, setCurrentTab] = useState<'single' | 'bulk'>('single');

  const editModeTabs = [
    {
      name: t('Single'),
      onClick: () => setCurrentTab('single'),
      current: currentTab === 'single',
    },
  ];

  const allTabs = [
    ...editModeTabs,
    {
      name: t('Bulk'),
      onClick: () => setCurrentTab('bulk'),
      current: currentTab === 'bulk',
    },
  ];

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      panelClassName="w-full sm:w-[75vw]"
      disableCloseOnOutsideClick
    >
      <div>
        <div className="text-2xl font-bold leading-9 text-gray-900">
          {employeeSelectedForEditing ? t('Edit Employee') : t('Add Employee')}
        </div>
        <Tabs tabs={employeeSelectedForEditing ? editModeTabs : allTabs} />
      </div>
      {currentTab === 'single' && (
        <div className="mt-5">
          <AddEmployeeForm
            employeeSelectedForEditingHasValidDepartment={
              employeeSelectedForEditingHasValidDepartment
            }
            setOpen={setOpen}
            employeeSelectedForEditing={employeeSelectedForEditing}
            refetchEmployeeList={refetchEmployeeList}
          />
        </div>
      )}
      {currentTab === 'bulk' && (
        <div className="mt-5">
          <AddEmployeesBulkForm
            setOpen={setOpen}
            setCurrentTab={setCurrentTab}
            refechEmployeeTable={refetchEmployeeList}
          />
        </div>
      )}
    </Modal>
  );
}

export default AddEmployeeModal;
